import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { useEffect } from "react";
import { $getRoot, $isParagraphNode } from "lexical";

export default function DirectionPlugin(): null {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return editor.registerUpdateListener(({ dirtyElements, tags }) => {
      // Don't process if it's a history merge to avoid fighting with history
      if (tags.has("history-merge")) {
        return;
      }

      editor.update(() => {
        const root = $getRoot();
        if (root.getDirection() !== "ltr") {
          root.setDirection("ltr");
        }
        
        // Enforce LTR on all block level nodes
        const children = root.getChildren();
        for (const child of children) {
          if ($isParagraphNode(child)) {
             if (child.getDirection() !== "ltr") {
               child.setDirection("ltr");
             }
          }
        }
      });
    });
  }, [editor]);

  return null;
}
